import SurvayLayout from './SurvayLayout';
import withStyles from 'react-jss';
import styles from './styles';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { savePage, goBackOnePage } from '@codex/pages/Survay/ducks/actions';
var mapStateToProps = function (state) {
    return {
        page: state.survay.page,
        isUIBlocked: state.blockui.isBlocked
    };
};
var mapDispatchToProps = function (dispatch) {
    return bindActionCreators({
        savePage: savePage,
        goBackOnePage: goBackOnePage
    }, dispatch);
};
export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(SurvayLayout));



//////////////////
// WEBPACK FOOTER
// ./src/containers/SurvayLayout/index.tsx
// module id = 1371
// module chunks = 0